import React from 'react';
import cl from "./SubscriptionCancellationsBrowseEditorItem.module.css";

const SubscriptionCancellationsBrowseEditorItem = ({style, dateText, fromText, text}) => {
    return (
        <div style={style}>
            <div className={cl.main}>
                <p className={cl.header}>
                    <span className={cl.headerDate}>{dateText}</span>
                    <span className={cl.headerFrom}>{fromText}</span>
                </p>
                <p className={cl.text}>{text}</p>
            </div>
        </div>
    );
};

export default SubscriptionCancellationsBrowseEditorItem;